import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, forwardRef } from "@angular/core";
import { FormItemBaseComponent } from "../form-item-base.component";

@Component({
  selector: "dropdown-form-item",
  templateUrl: "./dropdown-form-item.component.html",
  styleUrls: ["./dropdown-form-item.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: FormItemBaseComponent,
      useExisting: forwardRef(() => DropdownFormItemComponent),
    },
  ],
})
export class DropdownFormItemComponent extends FormItemBaseComponent<string> {
  @Input() public options: string[] = [];
  @Input() public baseValue?: string;

  @Output() public valueChange: EventEmitter<string> = new EventEmitter<string>();
}
